import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslate } from "react-admin";

import { SimpleDialog } from "../Dialog";
import { DataExportTable } from "./DataExportTable";
import { ExportServerCSVButton, ExportServerXLSXButton } from "../ExportDialog/ExportServerButton";

const useStyles = makeStyles((theme) => ({
	tableContainer: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		position: "relative",
	},
	contentWrapper: {
		display: "flex",
		flexDirection: "column",
		height: "calc(100vh - 300px)",
		position: "relative",
	},
}));

export const ExportModalBase = ({
	filters,
	titleButtons,
	endpoint,
	onModalClose,
	setExportDate,
	sort,
	tableRef,
}) => {
	const translate = useTranslate();
	const classes = useStyles();

	return (
		<SimpleDialog
			size="xl"
			open={true}
			onClose={onModalClose}
			title={translate(`resources.${endpoint}.export-dialog.title`)}
			titleButtons={
				<React.Fragment>
					{titleButtons}
					<ExportServerCSVButton endpoint={endpoint} filters={filters} sort={sort} />
					<ExportServerXLSXButton endpoint={endpoint} filters={filters} sort={sort} />
				</React.Fragment>
			}
		>
			<div className={classes.contentWrapper}>
				<TableContainer
					component={Paper}
					variant="outlined"
					elevation={0}
					className={classes.tableContainer}
				>
					<DataExportTable
						endpoint={endpoint}
						ref={tableRef}
						filters={filters}
						sort={sort}
						setExportDate={setExportDate}
					/>
				</TableContainer>
			</div>
		</SimpleDialog>
	);
};
